<div class="content layout-auto-1">
	<div class="search exg-search-bar span-layout spawn-reverse">
		<i class="search-action fa-regular fa-plus"
		   [class.disabled]="answersLength === 0"
		   (click)="openModalCreateFile()"
		   style="margin: 4px 4px;"></i>
	</div>
	<ng-container *ngIf="!documentPDF.isLoading && !init">
		<div class="content flex-container">
			<div class="flex-row">
				<ng-container *ngFor="let docElement of generatePageNumbers(documentPDF.docPDF.dokPages)">
					<div class="grid-auto-1">
						<div class="app-checkbox-multiSelection">
							<exg-checkbox [id]="documentPDF.docPDF.dokID + 'selection'"
							              [ngModel]="answers[docElement]"
							              (ngModelChange)="selection(docElement, $event)">
							</exg-checkbox>
						</div>
						<div class="md3-card-on-surface app-space width-400"
						     style="padding: 4px 8px; margin: 4px 4px;">
							<div style="cursor: pointer" (click)="selection(docElement, !answers[docElement])">
								<img src="{{excRestService.computeUrl('ImageThumbnailBig',{dokID: documentPDF.docPDF.dokID, page: docElement - 1})}}"
								     alt="Seite_{{docElement}}"
								     class="list-avatar-placeholder"
								     style="text-align: center; width: 460px; height: 660px"/>
							</div>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
	</ng-container>
	<div class="splash loading" *ngIf="documentPDF.isLoading">
		<div class="spinner">
			<div></div>
			<div></div>
			<div></div>
			<div></div>
		</div>
	</div>
</div>
